export default __webpack_public_path__ + "static/media/gantt_view_icon.44ac1b57.svg";